import { Box, Grid, SxProps, Theme, useTheme } from "@mui/material";
import { format } from "date-fns";
import { useIntl } from "react-intl";
import {
  EnrollmentAssigner,
  EnrollmentModel,
} from "services/organizationPortalClient";
import { eventDateTimeFormat, eventTimeFormat } from "utils/dateUtils";

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  component: {
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 15,
    paddingRight: 10,
  },
  info: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    paddingBottom: 1,
  },
});

export default function EnrollmentUserDetails({
  value,
}: {
  value: EnrollmentModel;
}) {
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();

  let assignedByValue = "";
  switch (value.assignedBy) {
    case EnrollmentAssigner.SelfUser:
      assignedByValue = t({ id: "selfUser" });
      break;
    case EnrollmentAssigner.Administrator:
      assignedByValue = t({ id: "administrator" });
      break;
  }

  return (
    <Box sx={styles.component}>
      <Grid sx={styles.info} container spacing={2}>
        {value.credits != null && (
          <Grid item md={2}>
            <strong>{t({ id: "credits" })}:</strong> {value.credits?.toFixed(2)}
          </Grid>
        )}
        <Grid item md={4}>
          <strong>{t({ id: "profession" })}:</strong>{" "}
          {value.professions?.map((p) => p.name).join(", ")}
        </Grid>
        <Grid item md={3}>
          <strong>{t({ id: "assignedBy" })}:</strong> {assignedByValue}
        </Grid>
        {value.eventStartDate && value.eventEndDate && (
          <Grid item md={3}>
            <strong>{t({ id: "eventDate" })}:</strong>{" "}
            {format(value.eventStartDate, eventDateTimeFormat) +
              " - " +
              (value.eventStartDate.getDay() === value.eventEndDate.getDay()
                ? format(value.eventEndDate, eventTimeFormat)
                : format(value.eventEndDate, eventDateTimeFormat))}
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
